export default __webpack_public_path__ + "5dfb09ed3fed061309f0d6016e2222a5.png";